export default {"src":"/_next/static/image/public/images/ic_close_dark_grey.ca6230bcc633ef5ba8210fb7ce5e34e6.svg","height":13,"width":13};